(function () {
  "use strict";

  // ── Image update ───────────────────────────────────────────────────────────

  function updateImages(productCard, swatch) {
    const image1 = swatch.getAttribute("data-image-1");
    const image2 = swatch.getAttribute("data-image-2");

    const primaryImage = productCard.querySelector(".product-card__image--primary");
    const secondaryImage = productCard.querySelector(".product-card__image--secondary");

    if (primaryImage && image1) {
      primaryImage.src = image1;
      primaryImage.srcset = "";
    }

    if (secondaryImage) {
      secondaryImage.src = image2 || image1 || "";
      secondaryImage.srcset = "";
    }
  }

  // ── Price update ───────────────────────────────────────────────────────────

  function updatePrice(productCard, swatch) {
    const template = swatch.querySelector(".price-template");
    if (!template) return;

    const priceList = productCard.querySelector("price-list");
    if (priceList) {
      priceList.outerHTML = template.innerHTML;
    }
  }

  // ── Card meta update (links, colour label, tracking attrs) ─────────────────

  function updateCardMeta(productCard, swatch) {
    const productUrl = swatch.getAttribute("data-product-url");
    const productHandle = swatch.getAttribute("data-product-handle");
    const productId = swatch.getAttribute("data-product-id");
    const color = swatch.getAttribute("data-color");

    if (productUrl) {
      productCard.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        link.href = productUrl;
      });
    }

    const colorNameEl = productCard.querySelector(".color_name");
    if (colorNameEl && color) colorNameEl.textContent = color;

    if (productHandle) productCard.setAttribute("data-current-product-handle", productHandle);
    if (productId) productCard.setAttribute("data-current-product-id", productId);

    // Each colour is its own product, so Constructor must see the colour now shown on the card
    updateTrackingAttrs(productCard, {
      "data-cnstrc-item-id": productId,
      "data-cnstrc-item-name": swatch.getAttribute("data-product-title"),
      "data-cnstrc-item-variation-id": swatch.getAttribute("data-variation-id"),
      "data-cnstrc-item-price": swatch.getAttribute("data-variation-price"),
    });

    return {productId, productHandle};
  }

  // ── Constructor tracking attrs ─────────────────────────────────────────────
  // Updates the element carrying data-cnstrc-item-id: the card itself, or its wrapper when the card
  // is rendered with cnstrc_skip (predictive search). Only attributes already present are touched.

  function updateTrackingAttrs(productCard, values) {
    const tracked = productCard.closest("[data-cnstrc-item-id]");
    if (!tracked) return;

    Object.keys(values).forEach((name) => {
      if (values[name] && tracked.hasAttribute(name)) tracked.setAttribute(name, values[name]);
    });
  }

  // ── Lazily hydrate a colour's quick-selection markup from its <template> ───
  // Non-active colours ship as inert <template> tags (see product-card.liquid) so their
  // per-size buy-forms never enter the live DOM until that colour is actually selected.

  function hydrateColorGroup(quickSelection, productId) {
    if (quickSelection.querySelector(`.swatches_kopstorm_inner[data-product-id="${productId}"]`)) return;

    const template = quickSelection.querySelector(`template.swatches_kopstorm_template[data-product-id="${productId}"]`);
    if (!template) return;

    quickSelection.insertBefore(template.content.cloneNode(true), template);
    template.remove();
  }

  // ── Quick selection panel update ───────────────────────────────────────────

  function updateQuickSelection(productCard, productId, productHandle) {
    const quickSelection = productCard.querySelector(".swatches_kopstorm");
    if (!quickSelection) return;

    hydrateColorGroup(quickSelection, productId);

    const allGroups = quickSelection.querySelectorAll(".swatches_kopstorm_inner");
    if (!allGroups.length) return;

    allGroups.forEach((g) => (g.style.display = "none"));

    const target = quickSelection.querySelector(`.swatches_kopstorm_inner[data-product-id="${productId}"]`);
    const shownGroup = target || allGroups[0];
    shownGroup.style.display = "flex";

    const shownGrid = shownGroup.querySelector(".swatches_kopstorm_grid");
    if (shownGrid) refreshGridAvailability(shownGrid);

    quickSelection.setAttribute("data-current-product-id", productId);

    if (productHandle) {
      const modal = productCard.querySelector("quick-buy-modal");
      if (modal) modal.setAttribute("handle", productHandle);
    }
  }

  // ── Full card state update — called on both hover and click ────────────────

  function applySwatchState(productCard, swatch, swatches) {
    swatches.forEach((s) => s.classList.remove("product-card-swatch--active"));
    swatch.classList.add("product-card-swatch--active");

    updateImages(productCard, swatch);
    updatePrice(productCard, swatch);

    const {productId, productHandle} = updateCardMeta(productCard, swatch);

    if (productId) {
      updateQuickSelection(productCard, productId, productHandle);
    }
  }

  // ── Quick-selection size clicks ─────────────────────────────────────────────
  // Each size is a plain span with data-variant-id (see product-card.liquid); clicking
  // one sets the hidden id input on the shared per-colour form and submits it via the
  // existing product-form custom element, which does the /cart/add.js fetch in the
  // background — no page reload, and no per-size form needed.

  // Sets the hidden variant id on a colour's shared add-to-cart form and submits it. Shared by
  // the flat quick-select list and the 2-row Size/Length grid below.
  function submitVariantForGroup(group, variantId) {
    const form = group?.querySelector('form[action*="/cart/add"]');
    const idInput = form?.querySelector('input[name="id"]');
    if (!form || !idInput || !variantId) return false;

    idInput.value = variantId;
    form.requestSubmit();
    return true;
  }

  function initQuickSelectSizeClicks(productCard) {
    const quickSelection = productCard.querySelector(".swatches_kopstorm");
    if (!quickSelection) return;

    quickSelection.addEventListener("click", (event) => {
      const sizeCard = event.target.closest(".card[data-variant-id]");
      if (!sizeCard) return;

      const group = sizeCard.closest(".swatches_kopstorm_inner");
      submitVariantForGroup(group, sizeCard.getAttribute("data-variant-id"));
    });
  }

  // ── Quick-select 2-row Size/Length grid (flare/wide-leg products only) ─────
  // See snippets/quick-select-sizes.liquid: for these products the hover panel renders one pill
  // row per option (e.g. Size, Length) instead of a flat "XS / Short, XS / Regular, ..." list.
  // The hidden flat list (data-option1/data-option2 on each .card) is the source of truth for
  // which combinations exist and are available; picking one value per row resolves to a variant
  // id there and submits it the same way as the flat quick-select (submitVariantForGroup).

  function refreshGridAvailability(grid) {
    if (!grid) return;

    const group = grid.closest(".swatches_kopstorm_inner");
    const flat = group?.querySelector(".swatches_kopstorm_flat");
    if (!flat) return;

    const availableCards = Array.from(flat.querySelectorAll(".card[data-variant-id]"));
    const rows = Array.from(grid.querySelectorAll(".swatches_kopstorm_grid-row"));

    const selectedByPosition = {};
    rows.forEach((row) => {
      const pos = row.getAttribute("data-option-position");
      const selected = row.querySelector(".swatches_kopstorm_grid-pill.is-selected");
      if (selected) selectedByPosition[pos] = selected.getAttribute("data-option-value");
    });

    // Rows are picked in order (Shopify allows up to 3 options): a row only unlocks once every
    // *earlier* row (by option position, e.g. Size before Length before a 3rd option) has a value.
    const sortedPositions = rows.map((row) => row.getAttribute("data-option-position")).sort((a, b) => Number(a) - Number(b));

    rows.forEach((row) => {
      const pos = row.getAttribute("data-option-position");
      const priorPositions = sortedPositions.slice(0, sortedPositions.indexOf(pos));
      const isLocked = priorPositions.some((p) => !selectedByPosition[p]);

      row.querySelectorAll(".swatches_kopstorm_grid-pill").forEach((pill) => {
        if (isLocked) {
          pill.classList.remove("is-unavailable");
          pill.classList.add("is-locked");
          return;
        }
        pill.classList.remove("is-locked");

        const value = pill.getAttribute("data-option-value");

        const hasMatch = availableCards.some((card) => {
          if (card.getAttribute("data-option" + pos) !== value) return false;
          // Must also match every OTHER row's current selection, not just one paired row.
          return Object.keys(selectedByPosition).every(
            (otherPos) => otherPos === pos || card.getAttribute("data-option" + otherPos) === selectedByPosition[otherPos],
          );
        });

        // A pill can lose its match after ANOTHER row's selection changes (e.g. the
        // previously-picked Length isn't offered for the newly-picked Size) - clear its
        // selected state too, instead of leaving a pill marked both selected and unavailable.
        pill.classList.toggle("is-unavailable", !hasMatch);
        if (!hasMatch) pill.classList.remove("is-selected");
      });
    });
  }

  // Clears every row's pick and re-locks the later rows (e.g. Length) so the grid is back to
  // its initial state, ready for the next add.
  function resetQuickSelectGrid(grid) {
    if (!grid) return;
    grid.querySelectorAll(".swatches_kopstorm_grid-pill").forEach((pill) => {
      pill.classList.remove("is-selected");
      pill.blur();
    });
    refreshGridAvailability(grid);
  }

  // Resets the grid once the add-to-cart has actually succeeded: the theme's product-form fires
  // `cart:change` on document after a successful /cart/add.js. If the add fails, no event fires
  // and the selection is kept so the customer can see what they picked. The listener is dropped
  // after 10s so a later, unrelated cart change can't reset this grid.
  function resetGridAfterAdd(grid) {
    let timeoutId;
    const onCartChange = () => {
      clearTimeout(timeoutId);
      resetQuickSelectGrid(grid);
    };
    document.addEventListener("cart:change", onCartChange, {once: true});
    timeoutId = setTimeout(() => document.removeEventListener("cart:change", onCartChange), 10000);
  }

  function initQuickSelectGrid(productCard) {
    const quickSelection = productCard.querySelector(".swatches_kopstorm");
    if (!quickSelection) return;

    quickSelection.querySelectorAll(".swatches_kopstorm_grid").forEach(refreshGridAvailability);

    quickSelection.addEventListener("click", (event) => {
      const pill = event.target.closest(".swatches_kopstorm_grid-pill");
      if (
        !pill ||
        pill.classList.contains("is-locked") ||
        pill.classList.contains("is-unavailable") ||
        pill.classList.contains("is-selected")
      )
        return;

      const grid = pill.closest(".swatches_kopstorm_grid");
      const row = pill.closest(".swatches_kopstorm_grid-row");
      if (!grid || !row) return;

      row.querySelectorAll(".swatches_kopstorm_grid-pill").forEach((p) => p.classList.remove("is-selected"));
      pill.classList.add("is-selected");

      refreshGridAvailability(grid);

      const group = grid.closest(".swatches_kopstorm_inner");
      const flat = group?.querySelector(".swatches_kopstorm_flat");
      const allRows = Array.from(grid.querySelectorAll(".swatches_kopstorm_grid-row"));
      const selectedByPosition = {};

      allRows.forEach((r) => {
        const pos = r.getAttribute("data-option-position");
        const selected = r.querySelector(".swatches_kopstorm_grid-pill.is-selected");
        if (selected) selectedByPosition[pos] = selected.getAttribute("data-option-value");
      });

      // Only submit once every row (however many options this product has) has a pick.
      const allPositionsSelected = allRows.every((r) => selectedByPosition[r.getAttribute("data-option-position")]);
      if (!allPositionsSelected || !flat) return;

      const matchCard = Array.from(flat.querySelectorAll(".card[data-variant-id]")).find((card) =>
        Object.keys(selectedByPosition).every((pos) => card.getAttribute("data-option" + pos) === selectedByPosition[pos]),
      );
      if (matchCard && submitVariantForGroup(group, matchCard.getAttribute("data-variant-id"))) {
        resetGridAfterAdd(grid);
      }
    });
  }

  // ── Constructor: picked size → card variation id / price ───────────────────
  // The quick-select pills carry data-cnstrc-btn="add_to_cart", but the beacon reads the variation
  // from the card. Runs on pointerdown/keydown (capture), i.e. before the click that adds to cart.

  // Grid pill: returns the variant card this pick completes (every row chosen), else null.
  function resolveGridPick(pill) {
    if (pill.classList.contains("is-locked") || pill.classList.contains("is-unavailable") || pill.classList.contains("is-selected")) return null;

    const grid = pill.closest(".swatches_kopstorm_grid");
    const flat = grid?.closest(".swatches_kopstorm_inner")?.querySelector(".swatches_kopstorm_flat");
    if (!grid || !flat) return null;

    const pillPosition = pill.getAttribute("data-option-position");
    const selectedByPosition = {[pillPosition]: pill.getAttribute("data-option-value")};
    const allRows = Array.from(grid.querySelectorAll(".swatches_kopstorm_grid-row"));

    allRows.forEach((r) => {
      const pos = r.getAttribute("data-option-position");
      if (pos === pillPosition) return;
      const selected = r.querySelector(".swatches_kopstorm_grid-pill.is-selected");
      if (selected) selectedByPosition[pos] = selected.getAttribute("data-option-value");
    });

    if (!allRows.every((r) => selectedByPosition[r.getAttribute("data-option-position")])) return null;

    return (
      Array.from(flat.querySelectorAll(".card[data-variant-id]")).find((card) =>
        Object.keys(selectedByPosition).every((pos) => card.getAttribute("data-option" + pos) === selectedByPosition[pos]),
      ) || null
    );
  }

  function syncPickedVariant(event) {
    const pick = event.target.closest?.(".swatches_kopstorm .card[data-variant-id], .swatches_kopstorm_grid-pill");
    if (!pick) return;

    const productCard = pick.closest(".product-card");
    const variantCard = pick.matches(".swatches_kopstorm_grid-pill") ? resolveGridPick(pick) : pick;
    if (!productCard || !variantCard) return;

    updateTrackingAttrs(productCard, {
      "data-cnstrc-item-variation-id": variantCard.getAttribute("data-variant-id"),
      "data-cnstrc-item-price": variantCard.getAttribute("data-variant-price"),
    });
  }

  document.addEventListener("pointerdown", syncPickedVariant, true);
  document.addEventListener("keydown", syncPickedVariant, true);

  // ── Init a single product card ─────────────────────────────────────────────


  function initCard(productCard) {
    if (productCard.hasAttribute("data-swatches-initialized")) return;
    productCard.setAttribute("data-swatches-initialized", "true");

    initQuickSelectSizeClicks(productCard);
    initQuickSelectGrid(productCard);

    const container = productCard.querySelector(".product-card-swatches");
    if (!container) return;

    const swatches = Array.from(container.querySelectorAll(".product-card-swatch"));
    if (!swatches.length) return;

    // ── Mobile quick buy open / close ─────────────────────────────────────
    // A trigger wired with aria-controls (e.g. flare products) opens the quick-buy-modal
    // dialog directly, so it must not also toggle the swatches_kopstorm popup here.
    const trigger = productCard.querySelector(".mobile_quickbuy_trigger");
    const closeButton = productCard.querySelector(".close_button");

    if (trigger && !trigger.hasAttribute("aria-controls")) {
      trigger.addEventListener("click", () => productCard.classList.add("quickbuy-active"));
    }
    if (closeButton) {
      closeButton.addEventListener("click", () => productCard.classList.remove("quickbuy-active"));
    }

    // ── Quick selection show/hide on figure hover (desktop only) ──────────
    const figure = productCard.querySelector(".product-card__figure");
    const quickSelect = productCard.querySelector(".swatches_kopstorm");

    if (figure && quickSelect) {
      figure.addEventListener("mouseover", () => {
        if (window.innerWidth > 700) quickSelect.style.display = "block";
      });
      figure.addEventListener("mouseout", () => {
        if (window.innerWidth > 700) quickSelect.style.display = "none";
      });
    }

    // ── Swatch events ─────────────────────────────────────────────────────
    // mouseenter → becomes active immediately, all card data updates
    // no mouseleave revert — last hovered swatch stays active
    // click → same behaviour, also covers touch devices
    swatches.forEach((swatch) => {
      swatch.addEventListener("mouseenter", function () {
        applySwatchState(productCard, this, swatches);
      });

      swatch.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        applySwatchState(productCard, this, swatches);
      });
    });

    // ── Set initial active state on load ────────────────────────────────
    const initialActive = swatches.find((s) => s.classList.contains("product-card-swatch--active")) || swatches[0];
    if (initialActive) {
      applySwatchState(productCard, initialActive, swatches);
    }
  }

  // ── Init all cards currently on the page ───────────────────────────────────

  function initAllCards() {
    document.querySelectorAll(".product-card").forEach(initCard);
  }

  // ── MutationObserver — picks up cards added by infinite scroll ─────────────

  function observeNewCards() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.(".product-card")) initCard(node);
          node.querySelectorAll?.(".product-card").forEach(initCard);
        });
      });
    });

    observer.observe(document.querySelector("main") || document.body, {childList: true, subtree: true});
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  function boot() {
    initAllCards();
    observeNewCards();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

function RenderCartSlider() {
  //console.log("cart_rec_slider");
  const cartSliderEl = document.querySelector(".cart_rec_slider");
  if (cartSliderEl) {
    // ✅ bfcache fix: destroy any existing Swiper instance before re-initializing,
    // otherwise back-navigation restores a dead/duplicated instance
    if (cartSliderEl.swiper) {
      cartSliderEl.swiper.destroy(true, true);
    }

    const pdpUpsellsSwiper = new Swiper(".cart_rec_slider", {
      slidesPerView: 3,
      spaceBetween: 10, // You can adjust this for spacing between slides
      loop: false, // Equivalent to infinite scrolling
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        400: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 3,
        },
        610: {
          slidesPerView: 4,
        },
      },
    });
    cartSliderEl.style.opacity = 1;
  }
}

function RenderPreOrder(preOrderElement, preOrderButton) {
  //console.log("RenderPreOrder");
  if (!preOrderElement) return;
  const dataUrl = preOrderElement.getAttribute("data-url");

  if (dataUrl) {
    fetch(dataUrl)
      .then((response) => response.json())
      .then((data) => {
        // Store response in a variable
        let jsonResponsePreOrder = data;

        let PreOrderVariant = jsonResponsePreOrder.variants.find(
          (variant) => variant.title == document.querySelector(".seletect-variant-id").getAttribute("data-title"),
        );
        document.querySelector('.custom-pre-order [name="id"]').value = PreOrderVariant.id;

        if (preOrderButton) {
          preOrderButton.addEventListener("click", function () {
            document.querySelector('form.custom-pre-order button[type="submit"]').click();
          });
        }

        // You can use jsonResponse as needed here
      })
      .catch((error) => console.error("Error fetching data:", error));
  }
}

function RenderTagLinks() {
  const facetform = document.querySelectorAll("facets-form form");
  document.querySelectorAll(".collection_product_tags a").forEach((taglink) => {
    taglink.addEventListener("click", (e) => {
      e.preventDefault();
      if (facetform) {
        facetform.forEach((form) => {
          form.setAttribute("action", taglink.getAttribute("href"));
        });
      }
      const checkbox = document.querySelector('[name="filter.v.availability"]');

      if (checkbox) {
        // checkbox.checked = false; // Toggle or set true/false
        checkbox.dispatchEvent(new Event("change", {bubbles: true}));
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  //console.log("DOM fully loaded and parsed");

  RenderTagLinks();
  RenderCartSlider();

  document.addEventListener("cart:refresh", (event) => {
    // console.log("cart:refresh");
    setTimeout(function () {
      RenderCartSlider();
    }, 1000);
  });
  document.addEventListener("cart:change", (event) => {
    //console.log("cart:change");
    setTimeout(function () {
      RenderCartSlider();
    }, 1000);
  });
  document.addEventListener("cart:prepare-bundled-sections", (event) => {
    //console.log("cart:prepare-bundled-sections");
    setTimeout(function () {
      RenderCartSlider();
    }, 1000);
  });

  if (document.querySelector(".varient_slider")) {
    const varientSlider = new Swiper(".varient_slider", {
      slidesPerView: 6.5, // Default for mobile
      spaceBetween: 3,
      freeMode: true, // Enables free scrolling
      freeModeMomentum: true, // Adds momentum for natural feel
      freeModeMomentumRatio: 1, // Controls momentum strength
      freeModeMomentumVelocityRatio: 0.5, // Controls speed of momentum
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // Tablet and up: maintain your original settings
        768: {
          slidesPerView: 7.5,
          spaceBetween: 5,
          freeMode: false, // Disable free mode on larger screens
        },
        992: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
        1200: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
      },
      // Optional: Disable navigation buttons on mobile if not needed
      on: {
        init: function () {
          if (window.innerWidth < 768) {
            //this.navigation.destroy();
          }
        },
        resize: function () {
          if (window.innerWidth < 768) {
            // this.navigation.destroy();
          } else {
            // this.navigation.init();
          }
        },
      },
    });

    // Get all slides as an array
    const slides = Array.from(varientSlider.slides);

    // Sort slides based on data-index attribute
    slides.sort((a, b) => {
      const indexA = parseInt(a.getAttribute("data-index")) || 6;
      const indexB = parseInt(b.getAttribute("data-index")) || 6;
      return indexA - indexB; // Ascending order (use indexB - indexA for descending)
    });

    // Remove all existing slides
    varientSlider.removeAllSlides();

    // Append sorted slides
    slides.forEach((slide) => varientSlider.appendSlide(slide));

    // Update Swiper to reflect changes
    varientSlider.update();

    document.querySelector(".cust_swatches").removeAttribute("style");
    const activeSlideIndex = Array.from(document.querySelectorAll(".varient_slider .swiper-slide")).findIndex((slide) =>
      slide.classList.contains("activeslide"),
    );
    //varientSlider.slideTo(activeSlideIndex);
  }

  let preOrderElement = document.querySelector(".custom-pre-order");

  const addToCartButton = document.querySelector('product-form button[type="submit"]');
  document.addEventListener("variant:change", function (event) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');
    // console.log(event.detail);

    if (document.querySelector(".seletect-variant-id")) {
      document.querySelector(".seletect-variant-id").setAttribute("data-title", event.detail.variant.title);
    }
    RenderPreOrder(preOrderElement, preOrderButton);
    //CustomWaisted();
    BundleProductLink();
    SizePagePopup();
  });

  document.addEventListener("facet:update", function (event) {
    // Wait for the actual filtered grid to land in the DOM instead of
    // guessing with a fixed delay — on slow connections the section swap
    // (theme.js) can take longer than a fixed timeout, which left infinite
    // scroll bound to the old, about-to-be-removed grid and silently dead.
    const container = document.querySelector("main") || document.body;
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      mutationObserver.disconnect();
      clearTimeout(fallbackTimer);
      RenderTagLinks();
      RenderInfiniteProduct?.();
    };

    const mutationObserver = new MutationObserver((mutations) => {
      const gridReplaced = mutations.some((m) =>
        Array.from(m.addedNodes).some((node) => node.nodeType === 1 && (node.matches?.(".product-list") || node.querySelector?.(".product-list"))),
      );
      if (gridReplaced) finish();
    });

    mutationObserver.observe(container, {childList: true, subtree: true});

    // Safety net in case the section markup doesn't match the expected shape.
    const fallbackTimer = setTimeout(finish, 2500);
  });

  if (document.querySelector(".pdp-upsells")) {
    document.querySelectorAll(".upsell-img-slider").forEach((slider, index) => {
      const nextEl = slider.querySelector(".swiper-button-next");
      const prevEl = slider.querySelector(".swiper-button-prev");

      const options = {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        watchOverflow: true,
      };

      if (nextEl && prevEl) {
        options.navigation = {
          nextEl,
          prevEl,
        };
      }

      new Swiper(slider, options);
    });
  }
  //console.log('preOrderElement', preOrderElement);
  if (preOrderElement) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');

    RenderPreOrder(preOrderElement, preOrderButton);
  }
});

// Feature Fact Swiper JS
if (document.querySelector(".feature_fact_slider")) {
  var swiper = new Swiper(".feature_fact_slider", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
  document.querySelector(".features_fact").removeAttribute("style");
}
if (document.querySelector(".upsell-img-slider")) {
  var swiper = new Swiper(".upsell-img-slider", {
    speed: 300,
    delay: 20,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
const showFeatureFacts = document.querySelectorAll(".show_ff_content");

if (showFeatureFacts) {
  showFeatureFacts.forEach((button) => {
    button.addEventListener("click", function () {
      button.parentNode.classList.toggle("active");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const productSelect = document.querySelectorAll(".product_list_upsell");

  // Function to fetch product variants
  async function fetchProductVariants(productHandle) {
    try {
      // Shopify AJAX API endpoint to fetch product data
      const response = await fetch(`${productHandle}.js`);
      const product = await response.json();
      return product.variants;
    } catch (error) {
      console.error("Error fetching product variants:", error);
      return [];
    }
  }

  // Function to update variant dropdown
  function updateVariantDropdown(variants, variantSelectOption) {
    // Clear existing options
    const variantSelect = variantSelectOption.nextElementSibling;
    //console.log(variantSelect);
    if (!variantSelect) return; // Ensure the select element exists
    variantSelect.innerHTML = "";

    // Populate new options
    variants.forEach((variant) => {
      const option = document.createElement("option");
      option.value = variant.id;
      option.textContent = variant.title;
      if (!variant.available) {
        option.disabled = true;
        option.style.textDecoration = "line-through";
        option.textContent += " (sold out)";
      }
      variantSelect.appendChild(option);
    });
  }

  // Event listener for product selection change
  if (productSelect) {
    productSelect.forEach((select) => {
      select.addEventListener("change", async () => {
        const selectedProductHandle = select.value;
        if (selectedProductHandle) {
          const variants = await fetchProductVariants(selectedProductHandle);
          updateVariantDropdown(variants, select);
        }
      });
    });
  }

  document.addEventListener("recommendations:change", function (event) {
    //console.log("recommendations changed");
  });

  const custSwatches = document.querySelector(".cust_swatches");
  const dynamicColor = document.querySelector(".dynamic_color");

  if (custSwatches && dynamicColor) {
    const container = document.querySelector(".varient_info_wrapper"); // the wrapper around all swatches
    const items = Array.from(container.querySelectorAll(".product_swatch_box_container"));

    // sort by data-index (numerically)
    items.sort((a, b) => +a.dataset.index - +b.dataset.index);

    // re-append sorted elements to the DOM
    items.forEach((item) => container.appendChild(item));

    const swatchBoxes = custSwatches.querySelectorAll(".product_swatch_box_container");

    function updateActiveColor() {
      const active = custSwatches.querySelector(".product_swatch_box_container.activeslide");
      if (active) {
        const color = active.getAttribute("data-color");
        dynamicColor.textContent = color;
      }
    }

    // Run once on load
    updateActiveColor();

    swatchBoxes.forEach((box) => {
      box.addEventListener("mouseenter", () => {
        const hoverColor = box.getAttribute("data-color");
        if (hoverColor) {
          dynamicColor.textContent = hoverColor;
        }
      });

      box.addEventListener("mouseleave", () => {
        updateActiveColor();
      });
    });
  }

  //expandable_icon(true);
  //CustomWaisted();
  BundleProductLink();
});


/* ===============================
   Waist Switcher Init
================================ */
function CustomWaisted() {
  const switcher = document.querySelector(".waist-switcher");
  if (!switcher) return;

  switcher.querySelectorAll("li").forEach((item) => {
    item.addEventListener("click", async () => {
      if (item.classList.contains("active")) return;

      const waist = item.innerText?.trim();
      if (!waist) return;

      window.selectedWaist = waist;

      setActiveWaist(item);
    });
  });

  // Restore state after rerender
  if (window.selectedWaist) {
    const li = [...switcher.querySelectorAll("li")].find((el) => el.innerText.trim() === window.selectedWaist);

    if (li) setActiveWaist(li);
  }

  /* ===============================
    Apply Waist Selection
  ================================ */
  async function setActiveWaist(activeItem) {
    document.querySelectorAll(".waist-switcher li").forEach((li) => {
      li.classList.toggle("active", li === activeItem);
    });

    const checkPreoder = document.querySelector(".custom-pre-order");
    if (checkPreoder) {
      if (activeItem.innerText.trim() == "High") {
        checkPreoder.style.display = "none";
      } else {
        checkPreoder.style.display = "block";
      }
    }

    /* ---- Variant update ---- */
    const idInput = document.querySelector('product-rerender [name="id"]');
    if (idInput && activeItem.dataset.variant) {
      idInput.value = activeItem.dataset.variant;
      idInput.dispatchEvent(new Event("change", {bubbles: true}));
    }

    /* ---- Gallery swap ---- */
    if (activeItem.dataset.handle) {
      await replaceProductGallery(activeItem.dataset.handle);
    }
  }

  /* ===============================
    Replace Product Gallery
  ================================ */
  function replaceImagesOnly(currentEl, newEl) {
    if (!currentEl || !newEl) return;

    const currentImgs = currentEl.querySelectorAll("img");
    const newImgs = newEl.querySelectorAll("img");

    newImgs.forEach((newImg, index) => {
      const currentImg = currentImgs[index];
      if (!currentImg) return;

      // Clone to avoid moving nodes
      const clonedImg = newImg.cloneNode(true);

      // Preserve lazy/loading state if needed
      clonedImg.loading = currentImg.loading || "lazy";

      currentImg.replaceWith(clonedImg);
    });
  }

  function replaceMediaInnerContent(currentEl, newEl) {
    if (!currentEl || !newEl) return;

    const currentMediaItems = currentEl.querySelectorAll(".product-gallery__media");
    const newMediaItems = newEl.querySelectorAll(".product-gallery__media");

    newMediaItems.forEach((newMedia, index) => {
      const currentMedia = currentMediaItems[index];
      if (!currentMedia) return;

      /* -------------------------------
       Replace IMG
    -------------------------------- */
      const currentImg = currentMedia.querySelector("img");
      const newImg = newMedia.querySelector("img");

      if (currentImg && newImg) {
        currentImg.replaceWith(newImg.cloneNode(true));
      }

      /* -------------------------------
       Replace / Sync scale badge
    -------------------------------- */
      const currentBadge = currentMedia.querySelector(".scale_badge_container");
      const newBadge = newMedia.querySelector(".scale_badge_container");

      if (newBadge) {
        if (currentBadge) {
          currentBadge.replaceWith(newBadge.cloneNode(true));
        } else {
          // Insert badge after image if missing
          currentMedia.appendChild(newBadge.cloneNode(true));
        }
      } else if (currentBadge) {
        // Remove old badge if new product doesn't have one
        currentBadge.remove();
      }
    });
  }

  async function replaceProductGallery(handle) {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", {bubbles: true}));

    const currentCarousel = document.querySelector("scroll-carousel");
    const currentNav = document.querySelector("product-gallery-navigation");

    if (!currentCarousel || !currentNav || !handle) return;

    try {
      const res = await fetch(`/products/${handle}?view=ajax`);
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, "text/html");

      const newCarousel = doc.querySelector("scroll-carousel");
      const newNav = doc.querySelector("product-gallery-navigation");

      if (!newCarousel || !newNav) return;

      /* ----------------------------------
       Replace ONLY carousel images
    ---------------------------------- */
      replaceMediaInnerContent(currentCarousel, newCarousel);

      /* ----------------------------------
       Replace ONLY thumbnail images
    ---------------------------------- */
      replaceImagesOnly(currentNav, newNav);

      if (typeof expandable_icon === "function") {
       // expandable_icon();
      }

      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", {bubbles: true}));
    } catch (err) {
      console.error("Gallery replace failed", err);
    }
  }
}

let _infiniteScrollTeardown = null;

function RenderInfiniteProduct() {
  // Tear down any previous instance (e.g. from a prior filter change) before
  // binding a new one, so observers/loaders don't stack up across facet updates.
  if (_infiniteScrollTeardown) {
    _infiniteScrollTeardown();
    _infiniteScrollTeardown = null;
  }

  const grid = document.querySelector(".product-list");
  const pagination = document.querySelector(".pagination");
  if (!grid || !pagination) return;

  let loading = false;
  let nextPageUrl = pagination.querySelector("a[rel='next']")?.href || null;

  pagination.style.display = "none";

  // Loader element
  const loader = document.createElement("div");
  loader.id = "infinite-loader";
  loader.style.cssText = "text-align:center; padding:20px 0; min-height:1px;";
  loader.innerHTML = `
  <style>
    #infinite-loader .loader-dots {
      display: inline-flex;
      gap: 6px;
      align-items: center;
    }
    #infinite-loader .loader-dots span {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #333;
      animation: dotBounce 1.2s infinite ease-in-out;
    }
    #infinite-loader .loader-dots span:nth-child(1) { animation-delay: 0s; }
    #infinite-loader .loader-dots span:nth-child(2) { animation-delay: 0.2s; }
    #infinite-loader .loader-dots span:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
      0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
      40%            { transform: scale(1.2); opacity: 1;   }
    }
  </style>
  <div class="loader-dots">
    <span></span>
    <span></span>
    <span></span>
  </div>
`;
  grid.insertAdjacentElement("afterend", loader);

  const setLoaderState = (state) => {
    const dots = loader.querySelector(".loader-dots");
    const existingError = loader.querySelector(".error-msg");

    // Clean up error msg if present
    if (existingError) existingError.remove();

    if (state === "loading") {
      if (dots) dots.style.visibility = "visible";
    } else if (state === "error") {
      if (dots) dots.style.visibility = "hidden";
      const errorMsg = document.createElement("p");
      errorMsg.className = "error-msg";
      errorMsg.innerHTML = `Failed to load products. <button id='retry-btn'>Retry</button>`;
      loader.appendChild(errorMsg);
      document.getElementById("retry-btn")?.addEventListener("click", loadMore);
    } else {
      if (dots) dots.style.visibility = "hidden";
    }
  };

  // ✅ Hide sold-out products initially
  const hideSoldOut = () => {
    grid.querySelectorAll(".sold_out_prod").forEach((card) => {
      card.style.display = "none";
    });
  };

  // ✅ Show and push sold-out products to the end (called only when all pages loaded)
  const pushSoldOutToEnd = () => {
    const allCards = [...grid.querySelectorAll(".product-card")];
    const available = allCards.filter((card) => !card.classList.contains("sold_out_prod"));
    const soldOut = allCards.filter((card) => card.classList.contains("sold_out_prod"));

    soldOut.forEach((card) => (card.style.display = "")); // ✅ Unhide
    [...available, ...soldOut].forEach((card) => grid.appendChild(card));
  };

  const loadMore = async () => {
    if (!nextPageUrl || loading) return;

    loading = true;
    setLoaderState("loading");

    // Watchdog: if the request ever hangs (e.g. flaky connection or a
    // server that never responds), `loading` would otherwise stay true
    // forever and permanently block every future scroll/observer trigger.
    const watchdog = new AbortController();
    const watchdogTimer = setTimeout(() => watchdog.abort(), 15000);

    try {
      const response = await fetch(nextPageUrl, {signal: watchdog.signal});
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newProducts = doc.querySelector(".product-list");
      const newPagination = doc.querySelector(".pagination");

      if (newProducts) {
        // Hide sold-out cards within just this batch before inserting, instead
        // of re-scanning the whole (ever-growing) grid on every batch — that
        // scan was O(n) per batch, i.e. O(n^2) over a long scroll session,
        // and was the main cause of the browser hanging on long scrolls.
        const batch = document.createElement("div");
        batch.innerHTML = newProducts.innerHTML;
        batch.querySelectorAll(".sold_out_prod").forEach((card) => {
          card.style.display = "none";
        });
        while (batch.firstChild) grid.appendChild(batch.firstChild);

        // Re-place marketing cards now that more product cards exist in the grid.
        positionAllMarketingCards();
      }

      nextPageUrl = newPagination?.querySelector("a[rel='next']")?.href ?? null;
      setLoaderState("hidden");

      if (!nextPageUrl) {
        stopWatching();
        pushSoldOutToEnd();
      }
    } catch (err) {
      console.error("Infinite scroll error:", err);
      setLoaderState("error");
    } finally {
      clearTimeout(watchdogTimer);
      loading = false;
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        loadMore();
      }
    },
    {rootMargin: "0px 0px 1200px 0px"},
  );

  observer.observe(loader);

  // Fallback for dragging the scrollbar thumb straight to the bottom: that
  // jump can skip past the loader's 1200px trigger zone in one motion
  // (especially with a footer/other sections below the grid), landing the
  // user at the true bottom with the loader already scrolled out of view
  // above them and no further room to scroll to re-trigger it. Checking the
  // actual document scroll position — not just the sentinel element — catches
  // that case regardless of how the user reached the bottom.
  let scrollCheckQueued = false;
  const checkNearBottom = () => {
    scrollCheckQueued = false;
    if (loading || !nextPageUrl) return;
    const distanceFromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    if (distanceFromBottom < 1200) loadMore();
  };
  const onScroll = () => {
    if (scrollCheckQueued) return;
    scrollCheckQueued = true;
    requestAnimationFrame(checkNearBottom);
  };

  window.addEventListener("scroll", onScroll, {passive: true});
  window.addEventListener("resize", onScroll, {passive: true});
  checkNearBottom();

  const stopWatching = () => {
    observer.disconnect();
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onScroll);
  };

  _infiniteScrollTeardown = () => {
    stopWatching();
    loader.remove();
  };

  // ✅ Sort sold-out products on initial load
  //pushSoldOutToEnd();
  //hideSoldOut();
}

/* =====================================================
   CONFIG
===================================================== */

/* ============================
   MILESTONES
============================ */

// Bar 2 — Free shipping (amount based, EUR). Only entries with
// `gift: true` trigger the free-gift popup / product add flow; "shipping"
// is purely informational (handled by checkout shipping rates elsewhere).
// The free cap reward (gift3) is retired — any cap left in a cart is
// removed by removeInvalidGifts.
const REWARD_MILESTONES = [
  {type: "amount", goal: 80, key: "shipping"},
];

/* ============================
   FREE GIFT PRODUCT IDS
============================ */

const FREE_GIFT_PRODUCT_IDS = [];

/* ============================
   MILESTONE → GIFT MAPPING
============================ */

const MILESTONE_GIFT_MAP = {};

/* =====================================================
   CART HELPERS
===================================================== */

let CURRENT_CART = null;
let FREE_GIFT_PRODUCTS = [];

function convertToEUR(amountInMinor) {
  if (Shopify?.currency?.rate) {
    return Number(amountInMinor) / 100 / Shopify.currency.rate;
  }
  return 0;
}

async function getCart() {
  const res = await fetch("/cart.js");
  if (!res.ok) throw new Error(`cart.js ${res.status}`);
  return res.json();
}

async function fetchProductById(productId) {
  const res = await fetch(`/products/${productId}.js`);
  if (!res.ok) throw new Error(`Product "${productId}" not found (${res.status})`);
  return await res.json();
}

let freeGiftProductsPromise = null;

function loadFreeGiftProducts() {
  // handleMilestones() can run concurrently (e.g. DOMContentLoaded and
  // cart-drawer:refreshed firing close together), and each path used to
  // start its OWN fetch loop over the same product handles since the old
  // `if (FREE_GIFT_PRODUCTS.length) return;` guard only checks state that's
  // set AFTER the first await — the second call would see it still empty
  // and duplicate every entry. Caching the in-flight promise means every
  // concurrent caller awaits the same single run instead of racing.
  if (freeGiftProductsPromise) return freeGiftProductsPromise;

  freeGiftProductsPromise = (async () => {
    if (FREE_GIFT_PRODUCTS.length) return;

    for (const id of FREE_GIFT_PRODUCT_IDS) {
      // A single bad/removed handle must not abort the whole batch — that
      // would reject this cached promise permanently (it's only built
      // once), silently breaking the free-gift popup for the rest of the
      // session since openFreeGiftPopup() never awaits/catches it.
      try {
        const product = await fetchProductById(id);
        if (product.available) {
          FREE_GIFT_PRODUCTS.push(product);
        }
      } catch (err) {
        console.warn(`[free-gift] could not load product "${id}":`, err.message);
      }
    }
  })();

  return freeGiftProductsPromise;
}
/*
function getCartQty(cart) {
  return cart.items.reduce((sum, i) => sum + i.quantity, 0);
}
*/
function getCartQty(cart) {
  return cart.items.reduce((sum, i) => {
    // Exclude the free gift from progress bar count
    if (
      i.product_title?.includes("Our Birthday Gift for You") ||
      i.product_title?.includes("Our Gift for You") ||
      i.product_title?.includes("Essence") ||
      i.product_title?.includes("Bundle") ||
      i.product_title?.includes("Jogger")
    )
      return sum;

    // Exclude any line carrying a "Bundle & Save" discount
    //  if (hasBundleSave(i)) return sum;

    return sum + i.quantity;
  }, 0);
}

function hasBundleSave(item) {
  const re = /Bundle.*Save/i; // matches "Bundle & Save" and "Bundle &amp; Save"
  return (
    (item.discounts || []).some((d) => re.test(d.title || "")) ||
    (item.line_level_discount_allocations || []).some((a) => re.test(a?.discount_application?.title || ""))
  );
}

/* =====================================================
   MILESTONE LOGIC
===================================================== */

function getGiftForMilestone(cart, milestoneKey) {
  return cart.items.find((item) => item.properties?._free_gift === "true" && item.properties?._milestone === milestoneKey);
}

/* =====================================================
   REWARD RAIL — BUY 2 GET 1 FREE (qty) + FREE SHIPPING (amount)
   -----------------------------------------------------
   The two milestones are independent metrics (see the comment atop
   snippets/reward-rail.liquid), so each node/segment is driven purely by
   its own progress — a cart can reach either one first.
===================================================== */

function updateRewardRail(qty, spentInEUR) {
  const rail = document.getElementById("reward-rail");
  const msg = document.getElementById("reward-rail-message");
  if (!rail || !msg) return;

  const qtyGoal = Number(rail.dataset.qtyGoal);
  const shipGoal = Number(rail.dataset.shipGoal);
  const currency = Shopify.currency.active;
  const rate = Shopify.currency.rate;

  const qtyReached = qty >= qtyGoal;
  const shipReached = spentInEUR >= shipGoal;

  // Each bar is an independent metric filled on its own scale.
  const qtyFillPct = Math.min((qty / qtyGoal) * 100, 100);
  const shipFillPct = Math.min((spentInEUR / shipGoal) * 100, 100);

  const qtyFill = document.getElementById("reward-rail-qty-fill");
  const shipFill = document.getElementById("reward-rail-ship-fill");
  if (qtyFill) qtyFill.style.width = qtyFillPct + "%";
  if (shipFill) shipFill.style.width = shipFillPct + "%";

  document.getElementById("reward-rail-node-qty")?.classList.toggle("is-reached", qtyReached);
  document.getElementById("reward-rail-node-ship")?.classList.toggle("is-reached", shipReached);

  if (!shipReached) {
    const remaining = (shipGoal - spentInEUR) * rate;
    msg.innerHTML = `You're <b>${remaining.toFixed(2)} ${currency}</b> away from <b>free shipping</b>`;
  } else if (!qtyReached) {
    const remaining = qtyGoal - qty;
    msg.innerHTML = `Free shipping unlocked! Add <b>${remaining}</b> more item${remaining === 1 ? "" : "s"} - your 3rd is <b>free</b>`;
  } else {
    msg.innerHTML = `<b>All rewards unlocked 🎉</b>`;
  }
}

/* =====================================================
   REMOVE INVALID GIFTS
===================================================== */

async function removeInvalidGifts(cart, spentInEUR) {
  // Gifts from a milestone that no longer exists (e.g. the retired free
  // cap) are always invalid.
  const activeGiftKeys = REWARD_MILESTONES.filter((m) => m.gift).map((m) => m.key);
  const orphan = cart.items.find((item) => item.properties?._free_gift === "true" && !activeGiftKeys.includes(item.properties?._milestone));
  if (orphan) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({id: orphan.key, quantity: 0}),
    });
    window.location.reload();
    return;
  }

  for (const m of REWARD_MILESTONES) {
    if (!m.gift) continue;

    if (spentInEUR < m.goal) {
      const gift = getGiftForMilestone(cart, m.key);
      if (gift) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({id: gift.key, quantity: 0}),
        });
        window.location.reload();
      }
    }
  }
}

/* =====================================================
   FREE GIFT POPUP
===================================================== */

let activeMilestoneKey = null;
let selectedVariantId = null;

async function renderFreeGiftPopup(milestoneKey, cart) {
  activeMilestoneKey = milestoneKey;
  selectedVariantId = null;

  await loadFreeGiftProducts();

  const popup = document.getElementById("free-gift-popup");
  const list = popup.querySelector(".free-gift-list");
  const addBtn = document.getElementById("add-free-gift-btn");

  list.innerHTML = "";
  addBtn.disabled = true;

  addBtn.addEventListener("click", (e) => {
    // Lock immediately
    addBtn.innerText = "Adding your free gift…";
    setTimeout(function () {
      addBtn.disabled = true;
      addBtn.setAttribute("aria-busy", "true");
    }, 500);
  });

  // Filter products allowed for this specific milestone
  const allowedHandles = MILESTONE_GIFT_MAP[milestoneKey] || [];
  const filteredProducts = FREE_GIFT_PRODUCTS.filter((p) => allowedHandles.includes(p.handle));

  // Auto-select if only one product is available for this milestone
  const autoSelect = filteredProducts.length === 1;

  filteredProducts.forEach((product) => {
    const item = document.createElement("div");
    item.className = "free-gift-item";

    const radio = document.createElement("input");
    radio.type = "radio";
    radio.name = "free-gift";

    // ADDED
    const radioTicker = document.createElement("div");
    radioTicker.className = "radio_ticker";
    // EDD ADDING

    const img = document.createElement("img");
    img.src = product.featured_image + "&width=70";

    const imgDiv = document.createElement("div");
    imgDiv.className = "free-image";
    imgDiv.appendChild(img);

    const title = document.createElement("strong");
    title.innerText = product.title;

    const price = document.createElement("span");
    price.innerText = "Free";
    price.className = "free-label";

    const midDiv = document.createElement("div");
    midDiv.className = "free-midblock";
    midDiv.append(title, price);

    let variantSelect = null;

    if (product.variants.length > 1) {
      variantSelect = document.createElement("select");
      // Enable select immediately if auto-selecting (only one product choice)
      variantSelect.disabled = !autoSelect;

      product.variants.forEach((v) => {
        const opt = document.createElement("option");
        opt.value = v.id;
        opt.innerText = v.title;
        opt.disabled = !v.available;
        variantSelect.appendChild(opt);
      });

      variantSelect.addEventListener("change", () => {
        selectedVariantId = variantSelect.value;

        const giftvarintID = document.getElementById("add-free-gift-id");
        if (giftvarintID) giftvarintID.value = selectedVariantId;

        const gift__milestone = document.getElementById("gift__milestone");
        if (gift__milestone) gift__milestone.value = activeMilestoneKey;
      });
    }

    radio.addEventListener("change", () => {
      // Disable all other selects first
      document.querySelectorAll(".free-gift-item select").forEach((s) => s && (s.disabled = true));

      if (variantSelect) {
        variantSelect.disabled = false;
        selectedVariantId = variantSelect.value;
      } else {
        selectedVariantId = product.variants[0].id;
      }

      addBtn.disabled = false;

      const giftvarintID = document.getElementById("add-free-gift-id");
      if (giftvarintID) giftvarintID.value = selectedVariantId;

      const gift__milestone = document.getElementById("gift__milestone");
      if (gift__milestone) gift__milestone.value = activeMilestoneKey;
    });

    // Auto-select when only one product is available for this milestone
    if (autoSelect) {
      radio.checked = true;
      selectedVariantId = variantSelect ? variantSelect.value : product.variants[0].id;
      addBtn.disabled = false;

      const giftvarintID = document.getElementById("add-free-gift-id");
      if (giftvarintID) giftvarintID.value = selectedVariantId;

      const gift__milestone = document.getElementById("gift__milestone");
      if (gift__milestone) gift__milestone.value = activeMilestoneKey;
    }

    const radioDiv = document.createElement("div");
    radioDiv.className = "free-radio";
    // radioDiv.appendChild(radio);
    radioDiv.append(radio, radioTicker);

    item.append(imgDiv, midDiv, radioDiv);
    if (variantSelect) item.appendChild(variantSelect);

    list.appendChild(item);
  });

  popup.classList.add("show");
}

function openFreeGiftPopup(key, cart) {
  // Nothing here awaits this call, so an uncaught rejection would fail
  // silently — the popup just never appears with no visible error.
  renderFreeGiftPopup(key, cart).catch((err) => console.error("[free-gift] popup failed to open:", err));
}

function closeFreeGiftPopup() {
  document.getElementById("free-gift-popup")?.classList.remove("show");
}

/* =====================================================
   CORE HANDLER
===================================================== */

async function handleMilestones() {
  const rail = document.getElementById("reward-rail");
  if (!rail) return;

  // ✅ bfcache fix: always trust the live cart, never a server-rendered
  // snapshot — that's stale after back-navigation.
  const cart = await getCart();
  CURRENT_CART = cart;
  const qty = getCartQty(cart);
  const spentInEUR = convertToEUR(cart.total_price);

  updateRewardRail(qty, spentInEUR);

  await removeInvalidGifts(cart, spentInEUR);

  // Only milestones with gift: true trigger the free-gift popup — free
  // shipping is informational only (no gift milestone is active now).
  const pending = REWARD_MILESTONES.find((m) => m.gift && spentInEUR >= m.goal && !getGiftForMilestone(cart, m.key));

  //console.log("pending", pending);

  if (pending) {
    openFreeGiftPopup(pending.key, cart);
  }

  const closePopBtn = document.getElementById("close-free-gift");
  //console.log("closePopBtn", closePopBtn);

  if (closePopBtn) {
    closePopBtn.addEventListener("click", () => {
      //console.log("closePopBtn1", closePopBtn);
      //console.log("closePopBtn2", document.getElementById("free-gift-popup"));
      document.getElementById("free-gift-popup")?.classList.remove("show");
    });
  }
}



/* =====================================================
   A/B OFFER CODE SYNC
===================================================== */

const OFFER_CODES = ["B2G1", "TIER10", "TIER20"];
let offerSyncInFlight = false;
let offerSyncTimer = null;
let lastOfferSignature = null;
let offerSyncCount = 0;

// Cart contents per variant; ignores line splits caused by discounts
function offerCartSignature(cart) {
  const perVariant = {};
  cart.items.forEach((i) => {
    perVariant[i.variant_id] = (perVariant[i.variant_id] || 0) + i.quantity;
  });
  const items = Object.keys(perVariant).sort().map((id) => `${id}:${perVariant[id]}`).join(",");
  return `${window.OFFER_VARIANT || "b2g1"}|${items}`;
}

async function setCartCodes(codes) {
  const res = await fetch("/cart/update.js", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({discount: codes.join(",")}),
  });
  if (!res.ok) throw new Error(`cart/update.js ${res.status}`);
  return res.json();
}

async function runOfferSync() {
  if (offerSyncInFlight) return;
  if (++offerSyncCount > 10) {
    console.warn("[offer] sync limit reached, stopping");
    return;
  }

  offerSyncInFlight = true;
  try {
    const cart = await getCart();
    const signature = offerCartSignature(cart);
    if (signature === lastOfferSignature) return;
    lastOfferSignature = signature;

    const variant = window.OFFER_VARIANT || "b2g1";
    const current = cart.discount_codes || [];
    const currentCodes = current.map((d) => d.code.toUpperCase());
    let otherCodes = currentCodes.filter((c) => !OFFER_CODES.includes(c));
    const qty = getCartQty(cart);

    let updated = null;

    // Kopstorm Super Bundle: a cart holding bundle lines keeps only the bundle code, so Buy 2 Get 1 Free
    // or the tiers never stack on top of the fixed bundle price. Without bundle lines the code is removed.
    const sbCode = String((window.KOP_BF && window.KOP_BF.bundleCode) || "").toUpperCase();
    const hasBundle = cart.items.some((i) => i.properties && i.properties._kop_sb);
    const sbStale = sbCode && !hasBundle && currentCodes.includes(sbCode);
    if (sbCode) otherCodes = otherCodes.filter((c) => c !== sbCode);

    if (sbCode && hasBundle) {
      if (!currentCodes.includes(sbCode) || currentCodes.some((c) => OFFER_CODES.includes(c))) {
        updated = await setCartCodes([...otherCodes, sbCode]);
      }
    } else if (variant === "b2g1") {
      if (sbStale || !currentCodes.includes("B2G1") || currentCodes.some((c) => c.startsWith("TIER"))) {
        updated = await setCartCodes([...otherCodes, "B2G1"]);
      }
    } else if (qty >= 2) {
      const tier20 = current.find((d) => d.code.toUpperCase() === "TIER20");
      if (sbStale || !tier20?.applicable) {
        updated = await setCartCodes([...otherCodes, "TIER20"]);
        const t20 = updated.discount_codes?.find((d) => d.code.toUpperCase() === "TIER20");
        if (!t20?.applicable) {
          updated = await setCartCodes([...otherCodes, "TIER10"]);
        }
      }
    } else if (sbStale) {
      updated = await setCartCodes(otherCodes);
    }

    if (updated) {
      lastOfferSignature = offerCartSignature(updated);
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {bubbles: true, detail: {source: "offer-sync"}})
      );
    }
  } catch (err) {
    console.error("[offer] sync failed:", err);
  } finally {
    offerSyncInFlight = false;
  }
}

function scheduleOfferSync() {
  clearTimeout(offerSyncTimer);
  offerSyncTimer = setTimeout(runOfferSync, 800);
}

document.addEventListener("DOMContentLoaded", scheduleOfferSync);
document.addEventListener("cart:change", scheduleOfferSync);
window.addEventListener("pageshow", (event) => {
  const nav = performance.getEntriesByType("navigation")[0];
  if (event.persisted || nav?.type === "back_forward") scheduleOfferSync();
});


/* =====================================================
   INIT
===================================================== */

document.addEventListener("DOMContentLoaded", () => {
  handleMilestones();
  RenderInfiniteProduct?.();
  SizePagePopup();
  ShopNowLook();
  SlideshowHotspots();
});

document.addEventListener("cart:change", () => {
  setTimeout(handleMilestones, 600);
  //close popup
});

/* =====================================================
   CART DRAWER RE-RENDER FIX
   -----------------------------------------------------
   The theme's <cart-drawer> component replaces its ENTIRE
   inner HTML with fresh server-rendered HTML on every
   cart:change / cart:refresh / pageshow (async fetch that
   resolves 1-2s later). That wipes the milestone bar's
   --progress, .reached dots, banner text, and kills the
   complementary products Swiper — which is why the bar
   "initializes once then clears after a few seconds".

   The theme dispatches "cart-drawer:refreshed" AFTER each
   replacement, so we re-apply our UI on that event.
===================================================== */

document.addEventListener("cart-drawer:refreshed", () => {
  handleMilestones();
  RenderCartSlider();
});

/* =====================================================
   BFCACHE FIX — back/forward navigation from checkout
   -----------------------------------------------------
   When customer goes to checkout and taps the browser
   back arrow, the page is restored from bfcache (or
   HTTP cache) — DOMContentLoaded does NOT fire again,
   and the restored DOM is stale (old cart totals, old
   complementary products). This handler re-syncs the
   milestone bar + cart drawer sections from live data.
===================================================== */

window.addEventListener("pageshow", async (event) => {
  const nav = performance.getEntriesByType("navigation")[0];
  const isBackNav = event.persisted || nav?.type === "back_forward";
  if (!isBackNav) return;

  try {
    // 1. Refresh milestone bar + progress from the live cart
    //    (handleMilestones now always fetches /cart.js itself)
    await handleMilestones();

    // 2. Ask the theme to re-render cart sections via the
    //    Section Rendering API — this refreshes
    //    .cart-drawer__complementary-products with fresh HTML.
    //    The existing cart:refresh listener also re-runs
    //    RenderCartSlider() after 1s.
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {bubbles: true}));
  } catch (err) {
    console.error("pageshow cart re-sync failed:", err);
  }
});


function normalizeBundleLabel(str) {
  return (str || "")
    .normalize("NFKC") // ™ → TM, nbsp → normal space
    .replace(/\s+/g, " ") // collapse all whitespace first
    .replace(/\s*\(\s*(select\s+your\s+)?(size|length)\s*\)\s*:?.*$/i, "") // strip (Size)/(Length) + anything after
    .replace(/\s*\([^)]*\)\s*:?\s*$/, "") // fallback: any other trailing "(…):"
    .trim()
    .toLowerCase();
}

function BundleProductLink() {
  if (!Array.isArray(window.bundleProductMap) || !window.bundleProductMap.length) return;

  const variantPicker = document.querySelector("variant-picker, .variant-picker");
  if (!variantPicker) return;

  // Remove single-variant cards from a previous run (prevents duplicates)
  variantPicker.querySelectorAll(".bundle_single_variant").forEach((el) => el.remove());

  const productsByLabel = new Map(
    window.bundleProductMap.map((item) => [normalizeBundleLabel(item.label), item])
  );

  const matchedLabels = new Set();

  // Cards rendered on a previous run still count as matched
  variantPicker.querySelectorAll(".bundle_matched").forEach((el) => {
    matchedLabels.add(el.dataset.bundleLabel);
  });

  const buildLink = (product, cls) => {
    const [title, color] = product.label.split("|").map((s) => s.trim());
    const wrapper = document.createElement("div");
    wrapper.style.cssText = "display:flex;align-items:center;gap:10px";
    wrapper.dataset.bundleLabel = product.label;
    if (cls === "mtch") wrapper.classList.add("bundle_matched");
    wrapper.innerHTML = `
      <a href="/products/${product.handle}" target="_blank" class="${cls}"
         style="display:flex;align-items:center;gap:10px;text-decoration:none;color:inherit">
        <img src="${product.image}" width="60" height="60" style="object-fit:cover">
        <div><strong>${title}</strong><br><span>Color: ${color || ""}</span></div>
      </a>`;
    return wrapper;
  };

  // Multi-variant bundle items: replace every option legend with a product card
  variantPicker.querySelectorAll(".variant-picker__option legend").forEach((legend) => {
    const option = legend.closest(".variant-picker__option");
    if (option) option.classList.add("bundle_variant");

    const key = normalizeBundleLabel(legend.textContent); // textContent, not innerText
    const product = productsByLabel.get(key);
    if (!product) {
      console.warn("Bundle: no match for", JSON.stringify(key));
      return;
    }

    matchedLabels.add(product.label);
    legend.replaceWith(buildLink(product, "mtch"));
  });

  // Single-variant items (e.g. Headband) that have no legend
  const unmatched = window.bundleProductMap.filter((item) => !matchedLabels.has(item.label));

  // Reverse so they keep map order when each is inserted at firstChild
  unmatched.reverse().forEach((product) => {
    const container = document.createElement("div");
    container.classList.add("bundle_variant", "bundle_single_variant");
    container.appendChild(buildLink(product, "unmtch"));
    variantPicker.insertBefore(container, variantPicker.firstChild);
  });
}

// Run once the DOM and the custom element are ready
function initBundleProductLink() {
  const run = () => requestAnimationFrame(BundleProductLink);

  if (
    window.customElements &&
    document.querySelector("variant-picker") &&
    customElements.get("variant-picker") === undefined
  ) {
    customElements.whenDefined("variant-picker").then(run);
  } else {
    run();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBundleProductLink);
} else {
  initBundleProductLink();
}

// 02-02-2026

function SizePagePopup() {
  /* -----------------------------
       INDICATOR INIT
    ------------------------------ */
  document.querySelectorAll(".size_guide_group").forEach((group) => {
    const buttons = group.querySelectorAll(".size_guide_btn");
    const indicator = group.querySelector(".size_guide_indicator");

    if (!buttons.length || !indicator) return;

    function updateIndicator(btn) {
      const btnRect = btn.getBoundingClientRect();
      const groupRect = group.getBoundingClientRect();
      const x = btnRect.left - groupRect.left;

      indicator.style.width = btn.offsetWidth + "px";
      indicator.style.transform = `translateX(${x}px)`;
    }

    // Initial active
    let activeBtn = group.querySelector(".size_guide_active") || buttons[0];
    activeBtn.classList.add("size_guide_active");
    updateIndicator(activeBtn);

    // Click handlers
    buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        buttons.forEach((b) => b.classList.remove("size_guide_active"));
        btn.classList.add("size_guide_active");

        updateIndicator(btn);
      });
    });

    // Recalc on resize
    let resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const current = group.querySelector(".size_guide_active");
        if (current) updateIndicator(current);
      }, 100);
    });
  });

  const CM_TO_IN = 0.393701;

  /* -----------------------------
       CONTEXT DETECTOR (PAGE / POPUP)
    ------------------------------ */
  function getActiveContainer(btn) {
    // size page tab content
    let tabContent = btn.closest(".size_guide_content");
    if (tabContent) return tabContent;

    // popup
    let popup = btn.closest("#size_guide_popup");
    if (popup) return popup;

    // fallback
    return document;
  }

  /* -----------------------------
     SIZE SYSTEM TOGGLE (EU / US / UK)
  ------------------------------ */
  document.querySelectorAll(".sg_toggle_wrapper:nth-child(2) .size_guide_btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const group = btn.closest(".size_guide_group");

      // Active state
      group.querySelectorAll(".size_guide_btn").forEach((b) => b.classList.remove("size_guide_active"));
      btn.classList.add("size_guide_active");

      const system = btn.textContent.trim().toLowerCase(); // eu | us | uk
      const container = getActiveContainer(btn);

      // Change table heading
      container.querySelectorAll(".size-system-th").forEach((th) => {
        th.textContent = system.toUpperCase() + " SIZE";
      });

      // Change td values
      container.querySelectorAll(".sizr-td").forEach((td) => {
        const value = td.dataset[system];
        if (!value) return;

        td.innerHTML = `${value} <span class="size_guide_eu">${system.toUpperCase()}</span>`;
      });
    });
  });

  /* -----------------------------
     MEASUREMENT UNIT TOGGLE (cm / in)
  ------------------------------ */
  document.querySelectorAll(".sg_toggle_wrapper:nth-child(1) .size_guide_btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      // Active state
      btn.parentElement.querySelectorAll(".size_guide_btn").forEach((b) => b.classList.remove("size_guide_active"));
      btn.classList.add("size_guide_active");

      const unit = btn.textContent.trim(); // cm | in
      const container = getActiveContainer(btn);

      container.querySelectorAll(".size_guide_table tbody tr").forEach((row) => {
        row.querySelectorAll(".cm_in").forEach((cell) => {
          if (!cell.dataset.cm) {
            cell.dataset.cm = cell.textContent.trim();
          }

          if (unit === "cm") {
            cell.textContent = cell.dataset.cm;
          } else {
            cell.textContent = convertRange(cell.dataset.cm);
          }
        });
      });
    });
  });

  /* -----------------------------
     RANGE CONVERTER (88–94 → 35–37)
  ------------------------------ */
  function convertRange(value) {
    if (!value) return "";

    if (value.includes("–") || value.includes("-")) {
      const [min, max] = value.split(/[–-]/).map((v) => parseFloat(v));
      return `${toIn(min)}–${toIn(max)}`;
    }
    return toIn(parseFloat(value));
  }

  function toIn(cm) {
    return Math.round(cm * CM_TO_IN);
  }

  /* -----------------------------
     RE-INIT INDICATOR (PAGE + POPUP)
  ------------------------------ */
  function reInitIndicators(scope) {
    scope.querySelectorAll(".size_guide_group").forEach((group) => {
      const buttons = group.querySelectorAll(".size_guide_btn");
      const indicator = group.querySelector(".size_guide_indicator");

      if (!buttons.length || !indicator) return;

      const activeBtn = group.querySelector(".size_guide_active") || buttons[0];
      if (!activeBtn) return;

      const btnRect = activeBtn.getBoundingClientRect();
      const groupRect = group.getBoundingClientRect();
      const x = btnRect.left - groupRect.left;

      indicator.style.width = activeBtn.offsetWidth + "px";
      indicator.style.transform = `translateX(${x}px)`;
    });
  }

  /* tab change (size page) */
  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".size_guide_tab");
    if (!tab) return;

    setTimeout(() => {
      reInitIndicators(document);

      // cm/in sync for active tab
      const activeContent = document.querySelector(".size_guide_content.sg_current");
      if (!activeContent) return;

      const unitGroup = activeContent.querySelector(".sg_toggle_wrapper:nth-child(1) .size_guide_group");
      if (!unitGroup) return;

      const activeUnitBtn = unitGroup.querySelector(".size_guide_active");
      if (!activeUnitBtn) return;

      const unit = activeUnitBtn.textContent.trim(); // cm | in

      activeContent.querySelectorAll(".size_guide_table tbody tr").forEach((row) => {
        row.querySelectorAll(".cm_in").forEach((cell) => {
          if (!cell.dataset.cm) {
            cell.dataset.cm = cell.textContent.trim();
          }

          if (unit === "cm") {
            cell.textContent = cell.dataset.cm;
          } else {
            cell.textContent = convertRange(cell.dataset.cm);
          }
        });
      });
    }, 50);
  });

  /* popup open re-init */
  document.addEventListener("click", function (e) {
    const popupTrigger = e.target.closest("[data-size-guide], .open-size-guide, .sg_open");
    if (!popupTrigger) return;

    setTimeout(() => {
      const popup = document.querySelector("#size_guide_popup");
      if (popup) {
        reInitIndicators(popup);
      }
    }, 100);
  });
}

function ShopNowLook() {
  if (!document.querySelector(".product_hotspots_wrapper")) return;
  let productHotspotsSlider = new Swiper(".products_hotspots_swiper", {
    slidesPerView: 1.1,
    spaceBetween: 4,
    centeredSlides: false,
    // initialSlide: 1,
    mousewheel: {
      forceToAxis: true, // Only respond to horizontal scroll
      releaseOnEdges: true,
      sensitivity: 0.5,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    //slideToClickedSlide: true,
    navigation: {
      nextEl: ".products_hotspots_button_next",
      prevEl: ".products_hotspots_button_prev",
    },
    breakpoints: {
      375: {slidesPerView: 1.2},
      576: {slidesPerView: 2},
      768: {slidesPerView: 2},
      992: {slidesPerView: 3},
      1200: {
        slidesPerView: 4,
        // simulateTouch: false, allowTouchMove: false, grabCursor: false
      },
    },
  });
  document.querySelectorAll(".product_hotspots_wrapper").forEach((section) => {
    const hotspots = section.querySelectorAll(".shop-the-look__hot-spot");
    const cards = section.querySelectorAll("product-card.product_hotspot_card");
    const wrapper = section.querySelector(".shop-the-look__image-wrapper");

    const hideAll = () => {
      cards.forEach((card) => {
        card.style.opacity = "0";
        card.style.visibility = "hidden";
        card.style.pointerEvents = "none";
      });
      hotspots.forEach((h) => h.setAttribute("aria-current", "false"));
    };

    hotspots.forEach((hotspot, index) => {
      hotspot.addEventListener("click", (e) => {
        e.stopPropagation();

        const isActive = hotspot.getAttribute("aria-current") === "true";
        hideAll();

        if (isActive) return; // toggle off — we're done

        hotspot.setAttribute("aria-current", "true");
        const activeCard = cards[index];
        if (!activeCard || !wrapper) return;

        const topPercent = parseFloat(hotspot.style.getPropertyValue("--shop-the-look-hot-spot-top"));
        const leftPercent = parseFloat(hotspot.style.getPropertyValue("--shop-the-look-hot-spot-left"));

        // Reset all positioning first
        activeCard.style.cssText += `
        top: ${topPercent}%;
        left: ${leftPercent}%;
        bottom: auto;
        right: auto;
        transform: translate(-50%, 20px);
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
      `;

        // Wait for browser to paint before measuring
        requestAnimationFrame(() => {
          const cardRect = activeCard.getBoundingClientRect();
          const wrapperRect = wrapper.getBoundingClientRect();

          let translateX = "-50%";
          let translateY = "20px";

          // --- Vertical: flip above if overflows bottom ---
          if (cardRect.bottom > wrapperRect.bottom) {
            activeCard.style.top = "auto";
            activeCard.style.bottom = `${100 - topPercent}%`;
            translateY = "-100%"; // place fully above the hotspot
          }

          // --- Horizontal: clamp to wrapper edges ---
          if (cardRect.right > wrapperRect.right) {
            activeCard.style.left = "auto";
            activeCard.style.right = "0";
            translateX = "0";
          } else if (cardRect.left < wrapperRect.left) {
            activeCard.style.left = "0";
            translateX = "0";
          }

          activeCard.style.transform = `translate(${translateX}, ${translateY})`;
        });
      });
    });

    // Close when clicking outside the section entirely
    document.addEventListener("click", (e) => {
      if (!section.contains(e.target)) {
        hideAll();
      }
    });
  });
}

//YOU MIGHT ALSO LIKE whishlist fixes
(function () {
  const selector = "product-list .wishlist-hero-custom-button";

  /**   * Helper function to dispatch the custom event   */
  function triggerWishlistEvent(element) {
    const ev = new CustomEvent("wishlist-hero-add-to-custom-element", {
      detail: element,
    });
    document.dispatchEvent(ev);
  }

  // 1. Run for existing elements on page load
  document.querySelectorAll(selector).forEach(triggerWishlistEvent);

  // 2. Set up MutationObserver to watch for changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" || mutation.type === "childList") {
        const target = mutation.target;
        // Check if the target itself matches or contains the selector
        if (target.nodeType === 1 && target.matches(selector)) {
          triggerWishlistEvent(target);
        } else if (target.nodeType === 1) {
          target.querySelectorAll(selector).forEach(triggerWishlistEvent);
        }
      }
    });
  });

  observer.observe(document.querySelector("main") || document.body, {
    childList: true,
    subtree: true,
  });
})();

if (document.querySelector(".pricing_swiper")) {
  let pricingSlider = new Swiper(".pricing_swiper", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    centeredSlides: false,
    // initialSlide: 1,
    mousewheel: {
      forceToAxis: true, // Only respond to horizontal scroll
      releaseOnEdges: true,
      sensitivity: 0.5,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    pagination: {
      el: ".pricing_swiper_pagination",
      clickable: true,
    },
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".pricing_swiper_button_next",
      prevEl: ".pricing_swiper_button_prev",
    },
    breakpoints: {
      375: {slidesPerView: 1.2},
      576: {slidesPerView: 2},
      768: {slidesPerView: 2, spaceBetween: 24},
      992: {slidesPerView: 3},
    },
  });
}

function SlideshowHotspots() {
  console.log("SlideshowHotspots");
  document.querySelectorAll(".slideshow__hotspots-wrapper").forEach((wrapper) => {
    const hotspots = wrapper.querySelectorAll(".shop-the-look__hot-spot");
    const cards = wrapper.querySelectorAll("product-card.product_hotspot_card");

    const resetCard = (card) => {
      card.style.top = "";
      card.style.left = "";
      card.style.bottom = "";
      card.style.right = "";
      card.style.transform = "";
      card.style.opacity = "0";
      card.style.visibility = "hidden";
      card.style.pointerEvents = "none";
    };

    const hideAll = () => {
      cards.forEach(resetCard);
      hotspots.forEach((h) => h.setAttribute("aria-current", "false"));
    };

    hotspots.forEach((hotspot, index) => {
      hotspot.addEventListener("click", (e) => {
        e.stopPropagation();

        const isActive = hotspot.getAttribute("aria-current") === "true";
        hideAll();
        if (isActive) return; // toggled off — done

        hotspot.setAttribute("aria-current", "true");
        const activeCard = cards[index];
        if (!activeCard) return;

        // Read the resolved position (desktop or mobile, chosen by the CSS media query)
        const hotspotStyle = getComputedStyle(hotspot);
        const topPercent = parseFloat(hotspotStyle.getPropertyValue("--shop-the-look-hot-spot-top"));
        const leftPercent = parseFloat(hotspotStyle.getPropertyValue("--shop-the-look-hot-spot-left"));

        // Place it fully reset — no leftover top/bottom/left/right from a previous open
        activeCard.style.top = `${topPercent}%`;
        activeCard.style.left = `${leftPercent}%`;
        activeCard.style.bottom = "auto";
        activeCard.style.right = "auto";
        activeCard.style.transform = "translate(-50%, 20px)";
        activeCard.style.visibility = "visible";
        activeCard.style.pointerEvents = "auto";
        // opacity stays 0 until we've placed + flipped it, so it never flashes at the wrong size/spot

        requestAnimationFrame(() => {
          const cardRect = activeCard.getBoundingClientRect();
          const wrapperRect = wrapper.getBoundingClientRect();

          let translateX = "-50%";
          let translateY = "20px";

          if (cardRect.bottom > wrapperRect.bottom) {
            activeCard.style.top = "auto";
            activeCard.style.bottom = `${100 - topPercent}%`;
            translateY = "-100%";
          }

          if (cardRect.right > wrapperRect.right) {
            activeCard.style.left = "auto";
            activeCard.style.right = "0";
            translateX = "0";
          } else if (cardRect.left < wrapperRect.left) {
            activeCard.style.left = "0";
            translateX = "0";
          }

          activeCard.style.transform = `translate(${translateX}, ${translateY})`;
          activeCard.style.opacity = "1";
        });
      });
    });

    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) hideAll();
    });
  });
}

/**
 * Positions marketing cards inside product grids.
 *
 * Marketing cards (see sections/main-collection.liquid) are rendered once, hidden, with a
 * `data-marketing-position` attribute holding their intended slot number. That number refers to
 * a slot among *actually rendered* product cards, not a raw product/pagination index, since
 * products can be skipped server-side (unavailable, hidden, out of stock, etc). This keeps the
 * card's placement correct no matter how many products got filtered out before it, and lets it
 * appear later once enough product cards exist (e.g. as more load in).
 */
function positionMarketingCards(root) {
  const marketingCards = root.querySelectorAll(":scope > [data-marketing-position]");
  if (marketingCards.length === 0) {
    return;
  }

  const productCards = Array.from(root.querySelectorAll(":scope > product-card:not([data-marketing-position])"));

  Array.from(marketingCards)
    .sort((a, b) => Number(a.dataset.marketingPosition) - Number(b.dataset.marketingPosition))
    .forEach((card) => {
      const position = Number(card.dataset.marketingPosition);
      if (!Number.isFinite(position) || position < 1) {
        return;
      }

      const anchor = productCards[position - 1];
      if (!anchor) {
        card.hidden = true;
        return;
      }

      if (card.previousElementSibling !== anchor) {
        anchor.after(card);
      }
      card.hidden = false;
    });
}

function positionAllMarketingCards() {
  document.querySelectorAll("product-list").forEach(positionMarketingCards);
  playMarketingVideosWhenNear();
}

// Marketing card videos have preload="none", no autoplay attribute and their poster in data-poster, so they cost
// nothing until the card comes within 400px of the viewport. The observer ignores cards while they are still hidden.
const marketingVideoObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const video = entry.target;
      marketingVideoObserver.unobserve(video);
      if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
      video.play().catch(() => {});
    }
  });
}, { rootMargin: "400px 0px" });

function playMarketingVideosWhenNear() {
  document.querySelectorAll("video.single_product_card_video").forEach((video) => marketingVideoObserver.observe(video));
}

positionAllMarketingCards();

// Re-run whenever a product grid changes: a facet/pagination AJAX swap replaces the whole
// section, and infinite scroll appends more product cards into the existing grid. Both show up
// as childList mutations, so a single subtree observer covers both without depending on either
// mechanism directly.
/*
new MutationObserver(() => positionAllMarketingCards()).observe(document.body, {
  childList: true,
  subtree: true,
});
*/

// Init slider hotspot in preview when any content changes made from backend
document.addEventListener("shopify:section:load", (event) => {
  if (event.target.querySelector(".products_hotspots_swiper") || event.target.matches?.(".products_hotspots_swiper")) {
    ShopNowLook(event.target);
  }
});

/* ==========================================================================
   Quick Selection (Quick Add) – product cards
   - Desktop: shown on card hover (CSS). Mobile: opened by .mobile_quickbuy_trigger.
   - Sizes / lengths / one-size: sets the variant id on the panel's hidden theme
     <product-form> and submits it, so the theme's AJAX cart + drawer handle the add
     (on_success=force_open_drawer) and the line item properties stay the same.
   - Colour switch: hover/tap on the existing .product-card-swatch[data-product-id]
     swaps the panel (no change needed in product-card-swatches.liquid). Can also be
     triggered with el.showProduct(id) or a "quick-selection:show-product" event on the card.
   ========================================================================== */
(() => {
  if (customElements.get('quick-selection')) return;

  const ADD_DONE_EVENTS = ['variant:add', 'cart:change', 'cart:error'];
  const ADD_TIMEOUT = 5000;

  class QuickSelection extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('product-card') || this.parentElement;
      this._abort = new AbortController();
      const { signal } = this._abort;

      this.addEventListener('click', (e) => this.onClick(e), { signal });

      if (this.card) {
        this.card.addEventListener('quick-selection:show-product', (e) => {
          if (e.detail?.productId) this.showProduct(e.detail.productId);
        }, { signal });

        const onSwatchIntent = (e) => {
          // Existing swatches from product-card-swatches.liquid: <button class="product-card-swatch" data-product-id="…">
          const swatch = e.target.closest('.product-card-swatch[data-product-id]');
          if (swatch && this.card.contains(swatch)) this.showProduct(swatch.dataset.productId);
        };
        // Capture phase: the theme's swatch script stops click propagation, so a bubbling listener never fires
        this.card.addEventListener('mouseover', onSwatchIntent, { signal, capture: true });
        this.card.addEventListener('focusin', onSwatchIntent, { signal, capture: true });
        this.card.addEventListener('click', onSwatchIntent, { signal, capture: true });

        // Desktop: leaving the card resets step 2 back to sizes
        this.card.addEventListener('mouseleave', () => {
          if (!this.classList.contains('is-open')) this.resetSteps();
        }, { signal });
      }
    }

    disconnectedCallback() {
      this._abort?.abort();
    }

    get activePanel() {
      return this.querySelector('.quick-selection__panel:not([hidden])');
    }

    /* ---------------- Clicks ---------------- */
    onClick(event) {
      const btn = event.target.closest('button');
      if (!btn || !this.contains(btn)) return;

      if (btn.hasAttribute('data-qs-close')) {
        event.preventDefault();
        this.close();
        return;
      }

      const panel = btn.closest('.quick-selection__panel');
      if (!panel || btn.disabled) return;

      if (btn.hasAttribute('data-qs-back')) {
        event.preventDefault();
        this.showStep(panel, null);
        return;
      }

      if (btn.hasAttribute('data-qs-size')) {
        event.preventDefault();
        this.showStep(panel, btn.dataset.qsSize);
        return;
      }

      if (btn.hasAttribute('data-qs-variant-id')) {
        event.preventDefault();
        this.addToCart(panel, btn);
      }
    }

    /* ---------------- Length steps ---------------- */
    showStep(panel, size) {
      const steps = panel.querySelectorAll('[data-qs-step]');
      steps.forEach((step) => {
        if (step.dataset.qsStep === 'size') {
          step.hidden = size !== null;
        } else {
          step.hidden = size === null || step.dataset.qsLengthFor !== size;
        }
      });

      panel.querySelectorAll('[data-qs-size]').forEach((b) => {
        b.classList.toggle('is-selected', size !== null && b.dataset.qsSize === size);
      });

      const visible = panel.querySelector('[data-qs-step]:not([hidden]) button:not([disabled])');
      if (size !== null && visible && this.contains(document.activeElement)) visible.focus();
    }

    resetSteps() {
      this.querySelectorAll('.quick-selection__panel').forEach((panel) => {
        if (panel.querySelector('[data-qs-step]')) this.showStep(panel, null);
        panel.querySelectorAll('.is-selected').forEach((b) => b.classList.remove('is-selected'));
      });
    }

    /* ---------------- Colour switching ---------------- */
    showProduct(productId) {
      const id = String(productId);
      let target = this.querySelector(`.quick-selection__panel[data-product-id="${CSS.escape(id)}"]`);

      if (!target) {
        const tpl = this.querySelector(`template.quick-selection__template[data-product-id="${CSS.escape(id)}"]`);
        if (!tpl) return; // colour has no quick-add panel (beyond swatch limit)
        tpl.replaceWith(tpl.content.cloneNode(true));
        target = this.querySelector(`.quick-selection__panel[data-product-id="${CSS.escape(id)}"]`);
        if (!target) return;
      }

      this.querySelectorAll('.quick-selection__panel').forEach((panel) => {
        panel.hidden = panel !== target;
      });
      this.dataset.activeProductId = id;
      this.resetSteps();
    }

    /* ---------------- Add to cart ---------------- */
    addToCart(panel, btn) {
      const form = panel.querySelector('.quick-selection__form form');
      const idInput = form?.querySelector('input[name="id"]');
      if (!form || !idInput) return;

      idInput.value = btn.dataset.qsVariantId;

      btn.classList.add('is-selected', 'is-loading');
      this.setAttribute('aria-busy', 'true');

      const done = new AbortController();
      const finish = () => {
        done.abort();
        clearTimeout(timer);
        btn.classList.remove('is-loading');
        this.removeAttribute('aria-busy');
        this.close();
      };
      ADD_DONE_EVENTS.forEach((name) => document.addEventListener(name, finish, { signal: done.signal, once: true }));
      const timer = setTimeout(finish, ADD_TIMEOUT);

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.querySelector('[type="submit"]')?.click();
      }
    }

    /* ---------------- Mobile open / close ---------------- */
    open(trigger) {
      document.querySelectorAll('quick-selection.is-open').forEach((el) => el !== this && el.close());
      this.classList.add('is-open');
      // Legacy custom.js / custom.css: .quickbuy-active on the card hides the trigger while the box is open
      this.card?.classList.add('quickbuy-active');
      this._trigger = trigger || null;
      this._trigger?.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.classList.remove('is-open');
      this.card?.classList.remove('quickbuy-active');
      this._trigger?.setAttribute('aria-expanded', 'false');
      this.resetSteps();
    }

    toggle(trigger) {
      this.classList.contains('is-open') ? this.close() : this.open(trigger);
    }
  }

  customElements.define('quick-selection', QuickSelection);

  /* Mobile trigger – flare/wide products keep opening the full quick-buy popup (aria-controls) */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.mobile_quickbuy_trigger');
    if (!trigger || trigger.hasAttribute('aria-controls')) return;

    const qs = trigger.closest('.product-card__figure')?.querySelector('quick-selection');
    if (!qs) return;

    event.preventDefault();
    event.stopPropagation();
    qs.toggle(trigger);
  });

  /* Tap outside closes the open box on mobile */
  document.addEventListener('click', (event) => {
    if (event.target.closest('quick-selection, .mobile_quickbuy_trigger')) return;
    document.querySelectorAll('quick-selection.is-open').forEach((el) => el.close());
  });
})();







